import { useRouter } from "next/compat/router";

const useQueryParam = <T = string>(
	slug: string,
): [T | undefined, (value?: T | null) => void] => {
	const router = useRouter();

	const value = router?.query[slug] as T | undefined;

	const setValue = (value?: T | null) => {
		delete router?.query[slug];
		router?.replace(
			{
				query: {
					...router?.query,
					...(value
						? {
								[slug]: value as string,
							}
						: {}),
				},
			},
			undefined,
			{ shallow: true },
		);
	};

	return [value, setValue];
};

export default useQueryParam;
